import React from "react";
import authService from "../../../_services/cart/authService";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { Field, FieldArray, Form, Formik } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import queryString from "query-string";
import {
  ErrorMessage,
  ESTADO_PRODUCTO,
  estadosProductos,
  history,
  LoadingBoton,
  MyToolTip,
  TIPO_CONVERSACION,
  TIPO_ENVIO,
  TIPO_REPUESTO,
} from "../../../_helpers";
import MiUploadImagenes from "../../../_helpers/MiUploadImagenes";
import GaleriaOrdenable from "../../../_helpers/GaleriaOrdenable";

import { productoActions, utilActions } from "../../../_actions";
import { busquedaActions } from "../../../_actions/busqueda.actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavBarLateral } from "../NavBarLateral";
import ReactSwitch from "react-switch";
import { ConsultaModal } from "../../publica/utils/ConsultaModal";
import { productoService } from "../../../_services";
import alertService from "../../../_services/cart/alert.service";

import CargadorVersiones from "../../../_helpers/CargadorVersiones";
const _ = require("lodash");

/**
 * Alta/edición de una publicación, en pasos.
 *
 * Antes era un único formulario con todo junto: el vendedor cargaba diez campos y
 * cuatro fotos y recién al final descubría si algo estaba mal, y el POST se iba con
 * todas las imágenes en base64 en el mismo body (de ahí los errores de parseo del
 * JSON cuando las fotos eran grandes).
 *
 * Ahora:
 *  - Cada paso valida sólo lo suyo, así el error aparece donde se cargó el dato.
 *  - La publicación se crea al terminar "Publicación" (el primer momento en que el
 *    backend tiene todo lo obligatorio) y desde ahí cada paso guarda sobre ese id.
 *  - Las fotos se suben de a una, apenas se eligen: el body nunca lleva más de una
 *    imagen por request.
 *  - Mientras se completa, la publicación queda PAUSADA; el estado elegido por el
 *    vendedor se aplica recién al confirmar en el último paso.
 */

/** Tope de fotos por publicación; antes eran cuatro ranuras fijas. */
const MAX_IMAGENES = 12;

const PASO_TIPO = 0;
const PASO_VEHICULO = 1;
const PASO_PUBLICACION = 2;
const PASO_IMAGENES = 3;
const PASO_RESUMEN = 4;

const PASOS = [
  { titulo: "Tipo", detalle: "Qué estás publicando" },
  { titulo: "Vehículo", detalle: "Marca, modelo y versión" },
  { titulo: "Publicación", detalle: "Precio, envío y descripción" },
  { titulo: "Fotos", detalle: "Imágenes y videos" },
  { titulo: "Resumen", detalle: "Revisá y publicá" },
];

/** '' -> null, para que Yup no cante typeError en los campos numéricos opcionales. */
const vacioANull = (value, original) => (original === "" ? null : value);

const anioMaximo = new Date().getFullYear() + 1;

const ESQUEMAS = [
  // Tipo
  Yup.object().shape({
    tipoRepuesto: Yup.object({
      id: Yup.mixed().required("Elegí el tipo de repuesto"),
    }),
  }),
  // Vehículo
  Yup.object().shape({
    marca: Yup.object({ id: Yup.mixed().required("Elegí la marca") }),
    modelo: Yup.object({ id: Yup.mixed().required("Elegí el modelo") }),
    version: Yup.object({ id: Yup.mixed().required("Elegí la versión") }),
    anio: Yup.number()
      .transform(vacioANull)
      .typeError("Solo números")
      .required("Requerido")
      .min(1900, "Año inválido")
      .max(anioMaximo, `No puede ser mayor a ${anioMaximo}`),
    kilometraje: Yup.number()
      .transform(vacioANull)
      .nullable()
      .typeError("Solo números")
      .min(0, "No puede ser negativo"),
  }),
  // Publicación
  Yup.object().shape({
    precio: Yup.number()
      .transform(vacioANull)
      .nullable()
      .typeError("Solo números")
      .min(0, "No puede ser negativo"),
    // Opcional: lo institucional (quienes somos, envios, horarios) va en la plantilla del
    // vendedor, que la ficha agrega al pie. Aca queda solo el detalle propio del repuesto.
    descripcion: Yup.string()
      .max(20000, "Máximo 20000 caracteres"),
    notaInterna: Yup.string().max(2000, "Máximo 2000 caracteres"),
  }),
  // Fotos
  Yup.object().shape({}),
  // Resumen
  Yup.object().shape({}),
];

/**
 * El mismo formulario sirve para el vendedor y para el back office: lo unico que
 * cambia es la ruta desde la que se entro, el carril de API que se usa y que el admin
 * tiene que elegir a nombre de que vendedor publica.
 */
const esModoAdmin = (location) =>
  (location?.pathname || "").startsWith("/admin");

const ESQUEMA_VENDEDOR = Yup.object().shape({
  vendedor: Yup.object({ id: Yup.mixed().required("Elegí el vendedor") }),
});

const TIPOS_ENVIO = [
  { id: TIPO_ENVIO.SIN_ENVIO, nombre: "Sin envío (retira el comprador)" },
  { id: TIPO_ENVIO.ENVIO_A_COORDINAR, nombre: "Envío a coordinar" },
];

const customSelect = {
  control: (provided) => ({
    ...provided,
    background: "transparent",
    display: "flex",
    flexWrap: "nowrap",
    borderColor: "hsl(0deg 0% 80%)",
    width: "100%",
    height: "48px",
  }),
};

class FormProducto extends React.Component {
  // Para leer los valores actuales fuera del render: el callback de subida de fotos
  // se dispara despues de un setFieldValue y el `values` del render ya quedo viejo.
  formikRef = React.createRef();

  get esAdmin() {
    return esModoAdmin(this.props.location);
  }

  get rutaListado() {
    return this.esAdmin ? "/admin/publicaciones" : "/vendedor/productos";
  }

  get rutaBaja() {
    return this.esAdmin
      ? "/admin/nuevoProductoDeBaja"
      : "/vendedor/nuevoProductoDeBaja";
  }

  state = {
    paso: PASO_TIPO,
    showConsulta: false,
    showMotorAsociado: false,
    grabando: false,
    guardadoEn: undefined,
    // El id se conoce recién cuando el backend crea la publicación; queda acá para
    // que los pasos siguientes actualicen en vez de crear una publicación nueva.
    eraNuevo: true,
    borrandoImagenId: undefined,
  };

  componentDidMount() {
    const { filtros } = this.props;

    const params = queryString.parse(this.props.location.search);

    if (params.id !== undefined) {
      if (this.esAdmin) {
        this.props.buscarYSeleccionarProductoBackOffice(params.id);
      } else {
        this.props.buscarYSeleccionarProductoAdmin(params.id);
      }
      this.setState({ eraNuevo: false });
    } else {
      this.props.limpiarProducto();
    }

    if (filtros === undefined) this.props.traerFiltros();
  }

  handleClose = () => this.setState({ showConsulta: false });

  abrirModalMensaje = () => this.setState({ showConsulta: true });

  handleCloseModal = () => this.setState({ showMotorAsociado: false });

  setGrabando = (grabando) => this.setState({ grabando });

  irAlPaso = (paso) => {
    this.setState({ paso });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /**
   * Guarda lo que haya hasta ahora y devuelve el id de la publicación.
   *
   * Mientras el alta no está terminada la publicación se guarda PAUSADA: si se
   * guardara ACTIVA, el backend dispararía las alertas a los compradores con una
   * publicación todavía a medio cargar.
   */
  guardar = (values, setFieldValue, { esFinal = false } = {}) => {
    const esAlta = !values.id;

    const aEnviar = productoActions.normalizarParaGuardar(
      {
        ...values,
        estado: esFinal || !esAlta ? values.estado : ESTADO_PRODUCTO.PAUSADA,
      },
      { conservarVendedor: this.esAdmin }
    );

    this.setGrabando(true);

    return (this.esAdmin
      ? productoService.addEditAdmin(aEnviar)
      : productoService.addEdit(aEnviar))
      .then((data) => {
        this.setGrabando(false);

        if (data && data.id && !values.id) {
          setFieldValue("id", data.id);
        }

        // El backend devuelve las fotos de la publicación ya subidas, con su id y su
        // url: se pisa la lista local para no volver a mandar el base64 en el próximo
        // guardado y para saber qué id borrar cuando el vendedor saca una foto.
        if (data && Array.isArray(data.imagenes)) {
          setFieldValue("imagenes", data.imagenes);
        } else {
          (values.imagenes || []).forEach((img, idx) => {
            if (!img.id && !img.guardada && img.base64) {
              setFieldValue(`imagenes[${idx}].guardada`, true);
            }
          });
        }

        this.setState({ guardadoEn: new Date() });

        return (data && data.id) || values.id;
      })
      .catch((error) => {
        this.setGrabando(false);
        alertService.error(error);
        return Promise.reject(error);
      });
  };

  /** El botón principal: avanza de paso, guardando cuando ya hay algo que guardar. */
  handleSubmitPaso = (values, { setFieldValue, setSubmitting }) => {
    const { paso } = this.state;
    setSubmitting(false);

    // Antes de "Publicación" faltan datos obligatorios (marca/modelo/tipo), así que
    // no hay nada que el backend pueda persistir todavía.
    if (paso < PASO_PUBLICACION) {
      this.irAlPaso(paso + 1);
      return;
    }

    if (paso === PASO_RESUMEN) {
      this.guardar(values, setFieldValue, { esFinal: true }).then((id) => {
        alertService.msg("Publicación guardada");

        const crearRepuestosBaja =
          values.esBaja && values.crearStock && this.state.eraNuevo;

        if (crearRepuestosBaja) {
          history.push(
            `${this.rutaBaja}?id=${id}` +
              (this.esAdmin && values.vendedor?.id
                ? `&vendedorId=${values.vendedor.id}`
                : "")
          );
        } else {
          history.push(this.rutaListado);
        }
      });
      return;
    }

    this.guardar(values, setFieldValue).then(() => this.irAlPaso(paso + 1));
  };

  /**
   * Sube la foto sola apenas se elige, para no acumular base64 en un solo POST.
   *
   * Los valores se leen del bag de Formik y no del render: `setFieldValue` es
   * asincrono, asi que el `values` del closure todavia no tiene la imagen nueva y
   * se terminaba mandando `imagenes: []`.
   */
  guardarImagen = (setFieldValue) => {
    const bag = this.formikRef.current;
    if (!bag || !bag.values.id) return Promise.resolve();

    return this.guardar(bag.values, setFieldValue).catch(() => {});
  };

  /**
   * Saca una foto de la publicación.
   *
   * Las que todavía no se subieron (sin id) se descartan del array y listo; las que ya
   * están en S3 hay que borrarlas en el backend, porque desde que la publicación lleva
   * N fotos sueltas ya no alcanza con pisar la ranura del mismo tipo.
   */
  borrarImagen = (values, index, arrayHelpers) => {
    const imagen = (values.imagenes || [])[index];
    if (!imagen) return;

    if (!imagen.id) {
      arrayHelpers.remove(index);
      return;
    }

    this.setState({ borrandoImagenId: imagen.id });

    const borrar = this.esAdmin
      ? productoService.borrarImagenAdmin
      : productoService.borrarImagen;

    borrar(values.id, imagen.id)
      .then(() => arrayHelpers.remove(index))
      .catch((error) => alertService.error(error))
      .finally(() => this.setState({ borrandoImagenId: undefined }));
  };

  /**
   * Nuevo orden de la galería: la primera foto es la que se ve en el listado.
   *
   * Se mueve primero en el form y después se persiste, así el arrastre se siente
   * inmediato. Si el PUT falla se vuelve al orden anterior, que es el que sigue
   * teniendo el backend.
   */
  reordenarImagenes = (values, arrayHelpers, desde, hasta) => {
    const imagenes = values.imagenes || [];
    if (desde === hasta || !imagenes[desde] || !imagenes[hasta]) return;

    arrayHelpers.move(desde, hasta);

    const reordenadas = [...imagenes];
    const [movida] = reordenadas.splice(desde, 1);
    reordenadas.splice(hasta, 0, movida);

    // Las que todavía se están subiendo no tienen id: el orden se guarda cuando terminan.
    const ids = reordenadas.map((img) => img.id).filter((id) => !!id);
    if (!values.id || ids.length !== reordenadas.length) return;

    const reordenar = this.esAdmin
      ? productoService.reordenarImagenesAdmin
      : productoService.reordenarImagenes;

    reordenar(values.id, ids).catch((error) => {
      arrayHelpers.move(hasta, desde);
      alertService.error(error);
    });
  };

  render() {
    let { filtros, producto } = this.props;
    const { paso } = this.state;

    const listadoPosiblesMotor = [
      TIPO_REPUESTO.TURBO_COMPRESOR,
      TIPO_REPUESTO.ALTERNADOR,
      TIPO_REPUESTO.BURRO_ARRANQUE,
      TIPO_REPUESTO.BOMBA_AGUA,
      TIPO_REPUESTO.VOLANTE_MOTOR,
      TIPO_REPUESTO.BOBINA_ENCENDIDO,
    ];

    const esNuevo =
      producto === undefined || producto.id === undefined || producto.id === "";

    let tipoRepuestosFinal = [];
    let tipoRepuestosMotor = [];

    /* Bajas y motores completos son de los negocios desarmaderos (marca de la
       cuenta). El back office carga para cualquiera. El back valida lo mismo. */
    const puedeBajasYMotores = this.esAdmin || authService.esDesarmadero();

    if (filtros && filtros.tipoRepuestos) {
      tipoRepuestosFinal = filtros.tipoRepuestos.filter(
        (it) =>
          it.nombre !== TIPO_REPUESTO.AUTO_DESARMADERO &&
          (puedeBajasYMotores || it.nombre !== TIPO_REPUESTO.MOTOR_04)
      );

      tipoRepuestosMotor = filtros.tipoRepuestos.filter((it) =>
        listadoPosiblesMotor.includes(it.nombre)
      );
    }

    if (utilActions.isEmpty(producto)) {
      producto = {};
    }

    let inic = {
      id: "",
      vendedor: { id: undefined },
      nuevoMotorAsociado: { id: undefined },
      tipoEnvio: TIPO_ENVIO.ENVIO_A_COORDINAR,
      marca: { id: undefined },
      modelo: { id: undefined },
      version: { id: undefined },
      tipoRepuesto: { id: undefined },
      motorAsociados: [],
      imagenes: [],
      cantidad: 1,
      anio: "",
      kilometraje: "",
      precio: 0,
      precioAConsultar: false,
      descripcion: "",
      notaInterna: "",
      estado: esNuevo ? ESTADO_PRODUCTO.ACTIVA : producto.estado,
      esBaja: !esNuevo
        ? producto.tipoRepuesto.nombre === TIPO_REPUESTO.AUTO_DESARMADERO
        : false,
      crearStock: true,
    };

    if (producto !== undefined) inic = utilActions.setearValores(inic, producto);

    return (
      <div className="dashboard">
        <NavBarLateral />
        <div className="dashboard__content">
          <Formik
            innerRef={this.formikRef}
            enableReinitialize={true}
            initialValues={inic}
            validationSchema={this.esquemaDelPaso(paso)}
            onSubmit={this.handleSubmitPaso}
          >
            {({ values, setFieldValue }) => (
              <div className={"th_verde-azulado"}>
                <Form>
                  <div className="dashboard__content-header">
                    <div className="dashboard__content-title">
                      <h2>{esNuevo ? "Nueva" : "Editar"} publicación</h2>
                      {this.esAdmin && (
                        <small className="stepper__ayuda">
                          Estás publicando desde el back office, a nombre del
                          vendedor que elijas.
                        </small>
                      )}
                    </div>
                  </div>

                  {this.renderStepper(values)}

                  <div className="dashboard__content-main">
                    {paso === PASO_TIPO &&
                      this.renderPasoTipo(
                        values,
                        setFieldValue,
                        esNuevo,
                        tipoRepuestosFinal,
                        filtros
                      )}

                    {paso === PASO_VEHICULO &&
                      this.renderPasoVehiculo(values, setFieldValue, filtros)}

                    {paso === PASO_PUBLICACION &&
                      this.renderPasoPublicacion(values, setFieldValue)}

                    {paso === PASO_IMAGENES &&
                      this.renderPasoImagenes(values, setFieldValue)}

                    {paso === PASO_RESUMEN &&
                      this.renderPasoResumen(values, filtros)}

                    {this.renderNavegacion(values)}
                  </div>

                  {this.renderModalMotorAsociado(
                    values,
                    setFieldValue,
                    tipoRepuestosMotor
                  )}
                </Form>
              </div>
            )}
          </Formik>
        </div>

        <Modal size="md" show={this.state.showConsulta} onHide={this.handleClose}>
          <Modal.Header closeButton>
            Escribinos lo más detallado que puedas qué marca/modelo/versión falta
          </Modal.Header>
          <Modal.Body>
            <ConsultaModal
              handleClose={this.handleClose}
              type={TIPO_CONVERSACION.NUEVA_MARCA}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  /** En el back office el primer paso pide ademas a nombre de quien se publica. */
  esquemaDelPaso(paso) {
    if (this.esAdmin && paso === PASO_TIPO) {
      return ESQUEMAS[paso].concat(ESQUEMA_VENDEDOR);
    }

    return ESQUEMAS[paso];
  }

  // --------------------------------------------------------------- stepper

  renderStepper(values) {
    const { paso, guardadoEn } = this.state;

    return (
      <div className="stepper">
        <ol className="stepper__pasos">
          {PASOS.map((item, idx) => {
            const estado =
              idx === paso ? "actual" : idx < paso ? "hecho" : "pendiente";

            return (
              <li key={item.titulo} className="stepper__paso" data-estado={estado}>
                <button
                  type="button"
                  className="stepper__boton"
                  // Sólo hacia atrás: adelantarse saltearía la validación del paso.
                  disabled={idx > paso}
                  onClick={() => this.irAlPaso(idx)}
                >
                  <span className="stepper__numero">
                    {idx < paso ? (
                      <FontAwesomeIcon icon="fa-solid fa-check" />
                    ) : (
                      idx + 1
                    )}
                  </span>
                  <span className="stepper__texto">
                    <strong>{item.titulo}</strong>
                    <small>{item.detalle}</small>
                  </span>
                </button>
              </li>
            );
          })}
        </ol>

        <div className="stepper__estado" role="status">
          {this.state.grabando ? (
            <span className="stepper__guardando">
              <FontAwesomeIcon icon="fa-solid fa-rotate" spin /> Guardando…
            </span>
          ) : guardadoEn ? (
            <span className="stepper__guardado">
              <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-up" /> Borrador
              guardado {guardadoEn.toLocaleTimeString("es-AR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
              {values.id ? ` · #${values.id}` : ""}
            </span>
          ) : (
            <span className="stepper__guardado stepper__guardado--pendiente">
              Se guarda solo a partir del paso 3
            </span>
          )}
        </div>
      </div>
    );
  }

  renderNavegacion(values) {
    const { paso, grabando } = this.state;
    const esUltimo = paso === PASO_RESUMEN;

    return (
      <div className="stepper__nav">
        <button
          className="button"
          type="button"
          data-type="complementary"
          onClick={() =>
            paso === PASO_TIPO
              ? history.push(this.rutaListado)
              : this.irAlPaso(paso - 1)
          }
        >
          {paso === PASO_TIPO ? "Cancelar" : "Volver"}
        </button>

        <button
          disabled={grabando}
          className="button"
          type="submit"
          data-type="primary"
        >
          {esUltimo
            ? values.estado === ESTADO_PRODUCTO.ACTIVA
              ? "Publicar"
              : "Guardar"
            : "Continuar"}
          <LoadingBoton grabando={grabando} />
        </button>
      </div>
    );
  }

  // ----------------------------------------------------------------- pasos

  renderPasoTipo(values, setFieldValue, esNuevo, tipoRepuestosFinal, filtros) {
    return (
      <>
        <p className="stepper__ayuda">
          Elegí qué estás publicando. Si es un vehículo dado de baja podés generar
          después, de una sola vez, todos los repuestos que salen de él.
        </p>

        <div className="dashboard__content-prod">
          {this.esAdmin && (
            <div className="form-group">
              <label htmlFor="vendedor">Vendedor</label>
              <Select
                inputId="vendedor"
                styles={customSelect}
                value={
                  (filtros?.vendedores || []).find(
                    (option) => option.id === values.vendedor?.id
                  ) || null
                }
                getOptionLabel={(option) =>
                  `${option.username}${
                    option.firstName || option.lastName
                      ? ` — ${option.firstName || ""} ${option.lastName || ""}`.trimEnd()
                      : ""
                  }`
                }
                getOptionValue={(option) => option.id}
                onChange={(so) => setFieldValue("vendedor", so || { id: undefined })}
                isSearchable={true}
                placeholder="Seleccioná el vendedor"
                options={filtros?.vendedores}
              />
              <ErrorMessage name="vendedor.id" />
            </div>
          )}

          {esNuevo && (this.esAdmin || authService.esDesarmadero()) && (
            <label className="switch__container mt-2 mb-2">
              <span>¿Es una baja o Motor 04?</span>
              <ReactSwitch
                onChange={(event) => {
                  setFieldValue("esBaja", event);
                  if (event) {
                    setFieldValue(
                      "tipoRepuesto",
                      productoActions.buscarBajaObjeto(filtros.tipoRepuestos)
                    );
                  } else {
                    // Ojo: tiene que quedar `undefined`, no `{}`. Un objeto acá
                    // viajaba como tipoRepuesto.id y el backend no lo podía parsear.
                    setFieldValue("tipoRepuesto", { id: undefined });
                  }
                }}
                checked={!!values.esBaja}
                onColor="#FF962E"
              />
            </label>
          )}

          {values.esBaja && (
            <label className="switch__container mt-2 mb-2">
              <span>
                ¿Querés crear automáticamente el stock de repuestos de esta baja?
                <MyToolTip
                  texto="Vas a poder configurar precio y stock de todos los repuestos legales del registro RUDAC al terminar esta publicación"
                  id="crear-stock"
                />
              </span>
              <ReactSwitch
                disabled={!esNuevo}
                onChange={(event) => {
                  setFieldValue("crearStock", event);

                  /*
                   * Con el stock apagado el select de envio se esconde (una baja
                   * sola no se despacha), asi que ahi si se fuerza SIN_ENVIO. Al
                   * prenderlo solo se propone un default: antes pisaba siempre
                   * con ENVIO_A_COORDINAR y le borraba el "Sin envio" al que
                   * volvia sobre este paso.
                   */
                  if (!event) {
                    setFieldValue("tipoEnvio", TIPO_ENVIO.SIN_ENVIO);
                  } else if (!values.tipoEnvio) {
                    setFieldValue("tipoEnvio", TIPO_ENVIO.ENVIO_A_COORDINAR);
                  }
                }}
                checked={!!values.crearStock}
                onColor="#FF962E"
              />
            </label>
          )}

          {!values.esBaja && (
            <div className="form-group">
              <label htmlFor="tipoRepuesto">Tipo de repuesto</label>
              <Select
                inputId="tipoRepuesto"
                styles={customSelect}
                value={
                  tipoRepuestosFinal.find(
                    (option) => option.id === values.tipoRepuesto?.id
                  ) || null
                }
                getOptionLabel={(option) => `${option.nombre}`}
                getOptionValue={(option) => option.id}
                onChange={(so) =>
                  setFieldValue("tipoRepuesto", so || { id: undefined })
                }
                isSearchable={true}
                placeholder="Seleccioná una"
                options={tipoRepuestosFinal}
              />
              <ErrorMessage name="tipoRepuesto.id" />
            </div>
          )}

          {values.tipoRepuesto?.nombre === TIPO_REPUESTO.MOTOR_04 && (
            <div className="form-group">
              <label>Repuestos asociados al motor</label>
              <ul className="lista-chips">
                {(values.motorAsociados || []).map((item) => (
                  <li key={item.id} className="chip">
                    {item.nombre}
                    <button
                      type="button"
                      aria-label={`Quitar ${item.nombre}`}
                      onClick={() =>
                        setFieldValue(
                          "motorAsociados",
                          values.motorAsociados.filter((it) => it.id !== item.id)
                        )
                      }
                    >
                      <FontAwesomeIcon icon="fa-solid fa-xmark" />
                    </button>
                  </li>
                ))}
              </ul>
              <button
                type="button"
                className="button"
                data-type="complementary-smallest"
                onClick={() => this.setState({ showMotorAsociado: true })}
              >
                <FontAwesomeIcon icon="fa-solid fa-plus" /> Agregar repuesto
              </button>
            </div>
          )}
        </div>
      </>
    );
  }

  renderPasoVehiculo(values, setFieldValue, filtros) {
    const modelos = (filtros?.modelos || []).filter(
      (it) => it.marca.id === values.marca?.id
    );
    const versiones = (filtros?.versiones || []).filter(
      (it) => it.modelo.id === values.modelo?.id
    );

    return (
      <>
        <p className="stepper__ayuda">
          ¿A qué vehículo pertenece? Cuanto más preciso, más gente lo encuentra.
          <Button
            className="button ms-3"
            type="button"
            data-type="complementary-smallest"
            onClick={this.abrirModalMensaje}
          >
            ¿Falta una versión? Escribinos
          </Button>
        </p>

        <div className="dashboard__content-prod">
          <div className="form-group">
            <label htmlFor="marca">Marca</label>
            <Select
              inputId="marca"
              styles={customSelect}
              value={
                (filtros?.marcas || []).find(
                  (option) => option.id === values.marca?.id
                ) || null
              }
              getOptionLabel={(option) => `${option.nombre}`}
              getOptionValue={(option) => option.id}
              noOptionsMessage={() =>
                "No encontramos la marca. Escribinos y la cargamos"
              }
              onChange={(so) => {
                setFieldValue("marca.id", so ? so.id : undefined);
                setFieldValue("modelo", { id: undefined });
                setFieldValue("version", { id: undefined });
              }}
              isSearchable={true}
              placeholder="Seleccioná una"
              options={filtros?.marcas || []}
            />
            <ErrorMessage name="marca.id" />
          </div>

          <div className="form-group">
            <label htmlFor="modelo">Modelo</label>
            <Select
              inputId="modelo"
              styles={customSelect}
              isDisabled={!values.marca?.id}
              value={
                modelos.find((option) => option.id === values.modelo?.id) || null
              }
              noOptionsMessage={() =>
                "No encontramos el modelo. Escribinos y lo cargamos"
              }
              getOptionLabel={(option) => `${option.nombre}`}
              getOptionValue={(option) => option.id}
              onChange={(so) => {
                setFieldValue("modelo.id", so ? so.id : undefined);
                setFieldValue("version", { id: undefined });
              }}
              isSearchable={true}
              placeholder={
                values.marca?.id ? "Seleccioná uno" : "Elegí primero la marca"
              }
              options={modelos}
            />
            <ErrorMessage name="modelo.id" />
          </div>

          <CargadorVersiones modeloId={values.modelo?.id}/>

          <div className="form-group">
            <label htmlFor="version">Versión</label>
            <Select
              inputId="version"
              styles={customSelect}
              isDisabled={!values.modelo?.id}
              value={
                versiones.find((option) => option.id === values.version?.id) ||
                null
              }
              noOptionsMessage={() =>
                "No encontramos la versión. Escribinos y la cargamos"
              }
              getOptionLabel={(option) => `${option.nombre}`}
              getOptionValue={(option) => option.id}
              onChange={(so) => setFieldValue("version.id", so ? so.id : undefined)}
              isSearchable={true}
              placeholder={
                values.modelo?.id ? "Seleccioná una" : "Elegí primero el modelo"
              }
              options={versiones}
            />
            <ErrorMessage name="version.id" />
          </div>

          <div className="form-group">
            <label htmlFor="anio">Año</label>
            <Field
              id="anio"
              className="input--outline"
              name="anio"
              type="number"
              inputMode="numeric"
              placeholder="2018"
            />
            <ErrorMessage name="anio" />
          </div>

          <div className="form-group">
            <label htmlFor="kilometraje">Kilometraje</label>
            <Field
              id="kilometraje"
              className="input--outline"
              name="kilometraje"
              type="number"
              inputMode="numeric"
              placeholder="Opcional"
            />
            <ErrorMessage name="kilometraje" />
          </div>
        </div>
      </>
    );
  }

  renderPasoPublicacion(values, setFieldValue) {
    const tiposEnvios = TIPOS_ENVIO;

    /*
     * El envío es parte de la compra por el sitio: una baja sola no se despacha, y una
     * publicación a consultar no se compra acá, así que el precio y la entrega se arreglan
     * juntos con el vendedor. En los dos casos el campo no se muestra y vale SIN_ENVIO.
     */
    const mostrarEnvio =
      (!values.esBaja || values.crearStock) && !values.precioAConsultar;

    return (
      <>
        <p className="stepper__ayuda">
          Al continuar guardamos la publicación como borrador, así no perdés nada de
          lo que cargaste.
        </p>

        <div className="dashboard__content-prod">
          {mostrarEnvio && (
            <div className="form-group">
              <label htmlFor="tipoEnvio">
                Tipo de envío
                {values.esBaja && values.crearStock && (
                  <MyToolTip
                    texto="El envío elegido para esta baja se usa en todos los repuestos que se creen a partir de ella"
                    id="tipo-envio"
                  />
                )}
              </label>
              <Select
                inputId="tipoEnvio"
                styles={customSelect}
                value={
                  tiposEnvios.find((option) => option.id === values.tipoEnvio) ||
                  null
                }
                getOptionLabel={(option) => option.nombre}
                getOptionValue={(option) => option.id}
                onChange={(so) => setFieldValue("tipoEnvio", so ? so.id : undefined)}
                isSearchable={false}
                placeholder="Seleccioná una"
                options={tiposEnvios}
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="estado">Estado de la publicación</label>
            <Select
              inputId="estado"
              styles={customSelect}
              value={
                estadosProductos.find((option) => option.id === values.estado) ||
                null
              }
              getOptionLabel={(option) => `${option.descripcion}`}
              getOptionValue={(option) => option.id}
              onChange={(so) => setFieldValue("estado", so ? so.id : undefined)}
              isSearchable={false}
              placeholder="Seleccioná una"
              options={estadosProductos}
            />
          </div>

          {!values.esBaja && !values.precioAConsultar && (
            <div className="form-group">
              <label htmlFor="precio">Precio</label>
              <Field
                id="precio"
                className="input--outline"
                name="precio"
                type="number"
                inputMode="decimal"
                min="0"
              />
              <ErrorMessage name="precio" />
            </div>
          )}
        </div>

        {/*
            Publicar sin precio.

            Antes una publicacion sin precio se pausaba sola, asi que el que todavia no
            tenia el numero cerrado simplemente no publicaba. Con esto la pieza se muestra
            igual y el precio se arregla por consulta: no entra al carrito ni al checkout,
            y el comprador solo puede escribirle al vendedor o crear una alerta.
        */}
        {!values.esBaja && (
          <label className="switch__container mt-2 mb-2">
            <span>
              Precio a consultar
              <MyToolTip
                texto="La publicación se muestra sin precio. No se puede comprar por el sitio: el comprador te consulta y arreglan el precio entre ustedes."
                id="precio-a-consultar"
              />
            </span>
            <ReactSwitch
              onChange={(event) => {
                setFieldValue("precioAConsultar", event);

                // El numero viejo no se deja escondido en el form: si se vuelve a apagar
                // el switch el precio se carga de nuevo, que es lo mismo que hace el
                // backend al guardar. El envio va con el: se esconde y queda en SIN_ENVIO,
                // igual que cuando se apaga el stock de una baja.
                if (event) {
                  setFieldValue("precio", "");
                  setFieldValue("tipoEnvio", TIPO_ENVIO.SIN_ENVIO);
                }
              }}
              checked={!!values.precioAConsultar}
              onColor="#FF962E"
            />
          </label>
        )}

        <div className="form-group--textarea">
          <div className="textarea-container">
            <label htmlFor="descripcion">Descripción (opcional)</label>
            <Field
              id="descripcion"
              as="textarea"
              name="descripcion"
              rows="5"
              className="input--outline"
              placeholder="Estado del repuesto, si tiene detalles, garantía, etc."
            />
            <ErrorMessage name="descripcion" />
          </div>

          <div className="textarea-container">
            <label htmlFor="notaInterna">
              Nota interna <small>(sólo la ves vos, no se publica)</small>
            </label>
            <Field
              id="notaInterna"
              as="textarea"
              name="notaInterna"
              rows="5"
              className="input--outline"
            />
            <ErrorMessage name="notaInterna" />
          </div>
        </div>
      </>
    );
  }

  renderPasoImagenes(values, setFieldValue) {
    const imagenes = values.imagenes || [];
    const { borrandoImagenId } = this.state;

    return (
      <>
        <p className="stepper__ayuda">
          Elegí todas las fotos juntas: se suben de a una apenas las seleccionás.
          Arrastralas de la manija para ordenarlas — la primera es la que se ve en el
          listado. Podés cargar hasta {MAX_IMAGENES} y los videos no pueden durar más de
          10 segundos.
        </p>

        <div className="dashboard__content-prod">
          <FieldArray
            name="imagenes"
            render={(arrayHelpers) => (
              <>
                <MiUploadImagenes
                  idUnique="fotosPublicacion"
                  arrayHelpers={arrayHelpers}
                  cantidadActual={imagenes.length}
                  maximo={MAX_IMAGENES}
                  onImagenAgregada={() =>
                    // Se difiere un tick para que Formik ya haya aplicado el push de la
                    // imagen antes de leer los valores del bag.
                    new Promise((resolve) =>
                      setTimeout(
                        () => resolve(this.guardarImagen(setFieldValue)),
                        0
                      )
                    )
                  }
                />

                {imagenes.length === 0 ? (
                  <p className="stepper__ayuda">Todavía no cargaste ninguna foto.</p>
                ) : (
                  <GaleriaOrdenable
                    className="galeria-fotos"
                    items={imagenes}
                    keyDe={(img, index) => img.id || `${img.nombre}-${index}`}
                    onReordenar={(desde, hasta) =>
                      this.reordenarImagenes(values, arrayHelpers, desde, hasta)
                    }
                    renderItem={(img, index, { arrastrando, destino, manijaProps }) => {
                      const esVideo = !!img.type && img.type.startsWith("video");
                      const fuente = img.base64 || img.url;
                      const borrando = !!img.id && img.id === borrandoImagenId;

                      return (
                        <div
                          data-indice={index}
                          className={
                            "galeria-fotos__item" +
                            (arrastrando ? " galeria-fotos__item--arrastrando" : "") +
                            (destino ? " galeria-fotos__item--destino" : "")
                          }
                        >
                          {esVideo ? (
                            <video className="galeria-fotos__preview" src={fuente} controls />
                          ) : (
                            // `draggable={false}`: sin esto el navegador arranca su propio
                            // arrastre de la imagen y cancela el gesto de reordenamiento.
                            <img
                              className="galeria-fotos__preview"
                              src={fuente}
                              draggable={false}
                              alt={img.descripcion || `Foto ${index + 1}`}
                            />
                          )}

                          {index === 0 && (
                            <span className="galeria-fotos__principal">Principal</span>
                          )}

                          <span
                            className="galeria-fotos__manija"
                            title="Arrastrar para reordenar"
                            {...manijaProps}
                          >
                            <FontAwesomeIcon icon="fas fa-grip-vertical" />
                          </span>

                          <button
                            type="button"
                            className="galeria-fotos__borrar"
                            title="Borrar foto"
                            disabled={borrando}
                            onClick={() =>
                              this.borrarImagen(values, index, arrayHelpers)
                            }
                          >
                            <FontAwesomeIcon
                              icon={borrando ? "fas fa-spinner" : "fas fa-trash"}
                              spin={borrando}
                            />
                          </button>
                        </div>
                      );
                    }}
                  />
                )}
              </>
            )}
          />
        </div>
      </>
    );
  }

  renderPasoResumen(values, filtros) {
    const buscarNombre = (lista, id) =>
      (lista || []).find((it) => it.id === id)?.nombre || "—";

    const filas = [
      ...(this.esAdmin
        ? [
            [
              "Vendedor",
              (filtros?.vendedores || []).find(
                (it) => it.id === values.vendedor?.id
              )?.username ||
                values.vendedor?.username ||
                "—",
            ],
          ]
        : []),
      ["Tipo", values.tipoRepuesto?.nombre || "—"],
      ["Marca", buscarNombre(filtros?.marcas, values.marca?.id)],
      ["Modelo", buscarNombre(filtros?.modelos, values.modelo?.id)],
      ["Versión", buscarNombre(filtros?.versiones, values.version?.id)],
      ["Año", values.anio || "—"],
      ["Kilometraje", values.kilometraje ? `${values.kilometraje} km` : "—"],
      [
        "Precio",
        values.precioAConsultar
          ? "A consultar"
          : values.precio
          ? `$ ${values.precio}`
          : "—",
      ],
      ...(values.precioAConsultar
        ? []
        : [
            [
              "Envío",
              TIPOS_ENVIO.find((it) => it.id === values.tipoEnvio)?.nombre || "—",
            ],
          ]),
      ["Estado", values.estado || "—"],
      [
        "Fotos",
        `${(values.imagenes || []).length} cargada${
          (values.imagenes || []).length === 1 ? "" : "s"
        }`,
      ],
    ];

    return (
      <>
        <p className="stepper__ayuda">
          Revisá que esté todo bien. Al confirmar, la publicación queda en estado{" "}
          <strong>{values.estado}</strong>.
        </p>

        <div className="resumen">
          <dl className="resumen__lista">
            {filas.map(([etiqueta, valor]) => (
              <div key={etiqueta} className="resumen__fila">
                <dt>{etiqueta}</dt>
                <dd>{valor}</dd>
              </div>
            ))}
          </dl>

          {values.descripcion && (
            <div className="resumen__descripcion">
              <h4>Descripción</h4>
              <p>{values.descripcion}</p>
            </div>
          )}
        </div>
      </>
    );
  }

  renderModalMotorAsociado(values, setFieldValue, tipoRepuestosMotor) {
    const disponibles = tipoRepuestosMotor.filter(
      (it) => !(values.motorAsociados || []).some((ma) => ma.id === it.id)
    );

    return (
      <Modal
        size="md"
        show={this.state.showMotorAsociado}
        onHide={this.handleCloseModal}
      >
        <Modal.Header closeButton>Seleccionar repuesto</Modal.Header>
        <Modal.Body>
          <Select
            styles={customSelect}
            value={null}
            getOptionLabel={(option) => `${option.nombre}`}
            getOptionValue={(option) => option.id}
            onChange={(so) => {
              if (!so) return;
              const finalMotor = _.clone(values.motorAsociados || []);
              finalMotor.push(so);
              setFieldValue("motorAsociados", finalMotor);
              this.handleCloseModal();
            }}
            isSearchable={true}
            placeholder="Seleccioná uno"
            options={disponibles}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

function mapState(state) {
  const { filtros, producto } = state.busqueda;
  return { filtros, producto };
}

const actionCreators = {
  traerFiltros: busquedaActions.traerFiltros,
  buscarYSeleccionarProductoAdmin:
    busquedaActions.buscarYSeleccionarProductoAdmin,
  buscarYSeleccionarProductoBackOffice:
    busquedaActions.buscarYSeleccionarProductoBackOffice,
  limpiarProducto: busquedaActions.limpiarProducto,
};

const connectedFormProducto = connect(mapState, actionCreators)(FormProducto);
export { connectedFormProducto as FormProducto };
